import { slice } from './slice';

// Action creators are generated for each case reducer function.
export const {
	setActionPanelIsOpen,
	setActionPanelMode,
	setCommentPanelIsOpen,
	setContentPanelMode,
	setContextPanelIsOpen,
	setEstimatePanelIsOpen,
	setFullScreenMode,
	setIsSaving,
	pushContextPanel,
	popContextPanel,
	setFloorLocked,
	setSkyLocked
} = slice.actions;

// Selectors returned by `slice.selectors` take the root state as their first argument.
export const {
	selectActionPanelIsOpen,
	selectActionPanelMode,
	selectCommentPanelIsOpen,
	selectContentPanelMode,
	selectContextPanel,
	selectContextPanelCount,
	selectContextPanelIsOpen,
	selectEstimatePanelIsOpen,
	selectIsFullScreen,
	selectIsSaving,
	selectLeftDock,
	selectLeftDockIsOpen,
	selectRightDock,
	selectRightDockIsOpen,
	selectIsFloorLocked,
	selectIsSkyLocked
} = slice.selectors;
